import React, { useContext, useEffect } from "react";
import { AuthContext } from "@/App";
import { t } from "i18next";
import { Icon, disabledEtlive } from "Icons/index";

const Maintenance = () => {
  const { getLoggedUser } = useContext(AuthContext);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Icon svg={disabledEtlive} width="10rem" height="10rem" />
      <div
        style={{
          fontSize: "1.25rem",
          fontWeight: 600,
          marginBottom: "1rem",
        }}
      >
        {t("delivery.maintenance.title")}
      </div>
      <div>{t("delivery.maintenance.description")}</div>
    </div>
  );
};

export default Maintenance;
